module.exports = __webpack_public_path__ + "img/feature-01-app.4c9723b9.svg";